// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-contact-us {
  background-color: #126fdb;
  margin-top: 10rem;
}

.footer-flex-text-font {
  font-family: "Manrope", sans-serif;
  font-weight: 500;
}

.text-section-contact-us {
  color: white;
  max-width: -moz-fit-content;
  max-width: fit-content;
  background-color: #126fdb;
  border-radius: 1rem;
  margin: 0.5rem 0.5rem 0.5rem 0.5rem;
}
.footer-grid-for-contacts {
  border: #116fdb solid 1px;
  margin-top: 3.5rem;
  margin-bottom: 0.4rem;
  max-width: -moz-fit-content;
  max-width: fit-content;
  background-color: #126fdb;
  border-radius: 12px;
}
.column-contact-us-footer-flex {
  margin-top: 1rem;
  background-color: #126fdb;
}

.jointWellFooter {
  color: #2f7abc;
}

.footer-each-section-flex {
  margin: 1rem 0.65rem 1rem 0.65rem;
}
/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
  sm, small: 600px
  md, medium: 900px
  lg, large: 1200px
  xl, extra-large: 1536px */
  /* margin: 2rem 6rem 2rem 6rem; */

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (max-width: 991px) {
    .text-section-contact-us {
      margin: 2rem 12rem 2rem 2rem;
    }
  }

  @media only screen and (max-width: 599px) {
    .text-section-contact-us {
      margin: 2rem 2rem 2rem 2rem;
    }
  }

  @media only screen and (max-width: 499px) {
    .text-section-contact-us {
      margin: 1rem 1rem 1rem 1rem;
    }
  }

  @media only screen and (max-width: 399px) {
    .text-section-contact-us {
      margin: 0rem 0rem 0rem 0rem;
    }
  }
  @media only screen and (min-width: 300px) {
    .footer-grid-for-contacts {
      max-width: 18rem;
    }
    .footer-flex-text-font {
      font-size: 1rem;
    }
  }
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (min-width: 500px) {
    .footer-grid-for-contacts {
      max-width: 26rem;
    }
    .footer-flex-text-font {
      font-size: 1rem;
    }
  }
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .footer-grid-for-contacts {
      max-width: 32rem;
    }
    .footer-flex-text-font {
      font-size: 1rem;
    }
  }
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .footer-grid-for-contacts {
      max-width: 34rem;
    }
    .footer-flex-text-font {
      font-size: 1rem;
    }
  }
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .footer-grid-for-contacts {
      max-width: 38rem;
    }

    .footer-flex-text-font {
      font-size: 0.6rem;
    }

    .footer-each-section-flex {
      margin: 1rem 0.5rem 1rem 0.5rem;
    }
    /* .text-section-contact-us {
      margin: 1rem 1rem 1rem 1rem;
    } */
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .footer-grid-for-contacts {
      max-width: 50rem;
    }

    .footer-flex-text-font {
      font-size: 0.75rem;
    }

    .footer-each-section-flex {
      margin: 1rem 0.65rem 1rem 0.65rem;
    }

    .text-section-contact-us {
      margin: 1rem 1rem 1rem 1rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Homepage/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAAsB;EAAtB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;AACA,yEAAyE;AACzE;EACE;;;;2BAIyB;EACzB,iCAAiC;;EAEjC,mDAAmD;EACnD;IACE;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;EACA;IACE;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;EACF;EACA,iDAAiD;EACjD;IACE;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;EACF;EACA,oEAAoE;EACpE;IACE;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;EACF;EACA,qDAAqD;EACrD;IACE;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;EACF;EACA,mDAAmD;EACnD;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,+BAA+B;IACjC;IACA;;OAEG;EACL;EACA,oEAAoE;EACpE;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,2BAA2B;IAC7B;EACF;AACF","sourcesContent":[".footer-contact-us {\n  background-color: #126fdb;\n  margin-top: 10rem;\n}\n\n.footer-flex-text-font {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n}\n\n.text-section-contact-us {\n  color: white;\n  max-width: fit-content;\n  background-color: #126fdb;\n  border-radius: 1rem;\n  margin: 0.5rem 0.5rem 0.5rem 0.5rem;\n}\n.footer-grid-for-contacts {\n  border: #116fdb solid 1px;\n  margin-top: 3.5rem;\n  margin-bottom: 0.4rem;\n  max-width: fit-content;\n  background-color: #126fdb;\n  border-radius: 12px;\n}\n.column-contact-us-footer-flex {\n  margin-top: 1rem;\n  background-color: #126fdb;\n}\n\n.jointWellFooter {\n  color: #2f7abc;\n}\n\n.footer-each-section-flex {\n  margin: 1rem 0.65rem 1rem 0.65rem;\n}\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n  sm, small: 600px\n  md, medium: 900px\n  lg, large: 1200px\n  xl, extra-large: 1536px */\n  /* margin: 2rem 6rem 2rem 6rem; */\n\n  /* Large devices (laptops/desktops, 992px and up) */\n  @media only screen and (max-width: 991px) {\n    .text-section-contact-us {\n      margin: 2rem 12rem 2rem 2rem;\n    }\n  }\n\n  @media only screen and (max-width: 599px) {\n    .text-section-contact-us {\n      margin: 2rem 2rem 2rem 2rem;\n    }\n  }\n\n  @media only screen and (max-width: 499px) {\n    .text-section-contact-us {\n      margin: 1rem 1rem 1rem 1rem;\n    }\n  }\n\n  @media only screen and (max-width: 399px) {\n    .text-section-contact-us {\n      margin: 0rem 0rem 0rem 0rem;\n    }\n  }\n  @media only screen and (min-width: 300px) {\n    .footer-grid-for-contacts {\n      max-width: 18rem;\n    }\n    .footer-flex-text-font {\n      font-size: 1rem;\n    }\n  }\n  /* Extra small devices (phones, 600px and down) */\n  @media only screen and (min-width: 500px) {\n    .footer-grid-for-contacts {\n      max-width: 26rem;\n    }\n    .footer-flex-text-font {\n      font-size: 1rem;\n    }\n  }\n  /* Small devices (portrait tablets and large phones, 600px and up) */\n  @media only screen and (min-width: 600px) {\n    .footer-grid-for-contacts {\n      max-width: 32rem;\n    }\n    .footer-flex-text-font {\n      font-size: 1rem;\n    }\n  }\n  /* Medium devices (landscape tablets, 768px and up) */\n  @media only screen and (min-width: 768px) {\n    .footer-grid-for-contacts {\n      max-width: 34rem;\n    }\n    .footer-flex-text-font {\n      font-size: 1rem;\n    }\n  }\n  /* Large devices (laptops/desktops, 992px and up) */\n  @media only screen and (min-width: 992px) {\n    .footer-grid-for-contacts {\n      max-width: 38rem;\n    }\n\n    .footer-flex-text-font {\n      font-size: 0.6rem;\n    }\n\n    .footer-each-section-flex {\n      margin: 1rem 0.5rem 1rem 0.5rem;\n    }\n    /* .text-section-contact-us {\n      margin: 1rem 1rem 1rem 1rem;\n    } */\n  }\n  /* Extra large devices (large laptops and desktops, 1200px and up) */\n  @media only screen and (min-width: 1200px) {\n    .footer-grid-for-contacts {\n      max-width: 50rem;\n    }\n\n    .footer-flex-text-font {\n      font-size: 0.75rem;\n    }\n\n    .footer-each-section-flex {\n      margin: 1rem 0.65rem 1rem 0.65rem;\n    }\n\n    .text-section-contact-us {\n      margin: 1rem 1rem 1rem 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
